import { useEffect, useRef, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import './style.scss'

const DropDownList = ({ list, translate = false, selectedValue, changeValue }) => {
  const [open, setOpen] = useState(false)
  const selectedRef = useRef(null)

  const { t } = useTranslation('basic')
  const displayName = (text) => translate ? t(text) : text

  useEffect(() => {
    if (open) {
      const click = () => { setOpen(false) }
      window.addEventListener('click', click)
      return () => {
        window.removeEventListener('click', click)
      }
    }
  }, [open])

  return (
    <div
      className='dropDown'
      onClick={() => {
        if (!open) setOpen(true)
      }}>
      <div
        ref={selectedRef}
        className='dropDown__selected'>
        {displayName(list.find(l => l.value === selectedValue)?.name)}
      </div>
      {open && <div className='dropDown__list'>
        {list.map(({ name, value }) => <div
          key={value}
          className={`dropDown__item ${selectedValue === value ? '--selected' : ''}`}
          onClick={() => {
            changeValue(value)
          }}>
          <p>{displayName(name)}</p>
        </div>)}
      </div>}
    </div>
  )
}

export default DropDownList